import * as React from 'react'

import {
  ShiftManagementShiftConfigurationFragment,
  ShiftManagementTemplateWeekFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import TableRow from '../Row'

interface Props {
  templateWeek: ShiftManagementTemplateWeekFragment
  shiftConfigurations: ShiftManagementShiftConfigurationFragment[]
}

const TableBody = ({ templateWeek, shiftConfigurations }: Props) => {
  return <TableRow templateWeek={templateWeek} shiftConfigs={shiftConfigurations} />
}

export default observer(TableBody)
